var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 219.794,
    viewBox: "0 0 430 219.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M755.764,205.572l-1.355,10.788-3.363,26.8H683.5c.527-6.006,1.249-14.65,2.019-23.982.076-.932.156-1.87.232-2.814,1.932-23.458,4.046-50,4.046-50l8.881,1.654,17.23,3.2,7.021,1.3,18.8,3.5c9.374,1.742,15.822,15.314,14.038,29.551Z",
    transform: "translate(-344.961 -84.087)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M711.4,79.358l8.307,14.537-15.966,11.315L696.93,87.341Z",
    transform: "translate(-351.691 -40.021)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 20.579,
    cy: 20.579,
    r: 20.579,
    transform: "translate(328.554 12.19)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M677.71,45.565c-1.634-2.487-.993-3.788-2.361-4.7,0,0-.551-.368-4.49-.577h0c-.882-6.349-1.983-7.118-1.983-7.118a4.63,4.63,0,0,0-4.324-.056c-2.478,1.148-2.191,3.627-3.859,4.1-2.3.655-6.5-3.039-6.911-7.269-.337-3.45,1.886-6.8,2.768-6.624s2.967-2.5,4.1-2.455c.772.028,3.925-1.342,4.773-1.235.926.117,3.981,1.711,4.108,1.347.884-2.531.625-3.233,1.375-3.957,1.33-1.283,3.505-.39,6.918.09,7.022.987,8.248-1.329,11.847.241,1.818.793,3.339,2.931,6.307,7.175,4.151,5.935,6.226,8.9,6.24,12.364.014,3.53-1.7,3.306-2.446,8.531-.836,5.817.94,8.477-1,10.366-1.5,1.461-4.547,1.807-6.148.525-2.741-2.195.846-7.49-2.187-11.359-1.862-2.375-5.607-3.432-7.323-2.258-1.94,1.327-.871,5.224-2.235,5.593-1.168.316-2.88-2.289-3.165-2.723Z",
    transform: "translate(-330.054 -8.196)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M734.865,169.4c-.574,9.814-2.854,12.913-3.652,24.5-.174,2.545-.279,5.5-.279,9.021,0,.9,0,1.766,0,2.615a43.131,43.131,0,0,1-.245,5.244,23.121,23.121,0,0,1-.888,4.241H685.485c0-.01,0-.02-.01-.03a30.8,30.8,0,0,1-.549-3.238q-.06-.494-.1-.973c-.04-.374-.075-.743-.11-1.108a28.751,28.751,0,0,0-.589-4.136,10.594,10.594,0,0,0-2.8-5.164,14.138,14.138,0,0,0-1.945-1.656c-.125-.085-.245-.17-.369-.255-1.766-1.213-3.438-2.086-4.885-4.56-.025-.035-.045-.075-.065-.11a15.162,15.162,0,0,1-1.367-3.088,10.064,10.064,0,0,1-.254-5.583c1.282-4.8,6.032-5.279,9.914-10.129a17.025,17.025,0,0,0,1.227-1.746c1.756-2.854,2.23-5.369,2.789-8.357.09-.484.169-.963.234-1.427.05-.349.095-.694.13-1.033a27.19,27.19,0,0,0-.2-7.5c-1.187-7.19-4.69-11.64-2.216-18.092a16.377,16.377,0,0,1,2.994-4.85c2.355-2.759,4.775-4.55,4.356-8.113-.424-3.593-3.149-4.087-3.453-7.225a8.188,8.188,0,0,1,1.337-4.9v0c3.114-5.284,10.887-10.149,15.826-9.994a4.958,4.958,0,0,1,2.395.624c2.44,1.437,1.422,4.575,5.16,8.976a20.463,20.463,0,0,0,7.115,5.194c4.725,2.465,8.567,9.735,11.176,19.03.02.07.04.14.06.215a106.429,106.429,0,0,1,3.313,19.14c.239,2.839.379,5.693.409,8.517.025,2.255-.025,4.211-.13,5.953Z",
    transform: "translate(-339.273 -51.583)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(343.907 71.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M717.141,301.742l-.9,2.515-.569,1.576-1.317,3.668-1.527,4.241H703.01l1.646-4.241.763-1.976,1.267-3.268,2.125-5.488Z",
    transform: "translate(-698.644 -221.947)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M742.448,156.29c-.025.325-.06.684-.095,1.073-.389,3.962-1.307,11.052-2.649,19.14-.708,4.266-1.537,8.812-2.47,13.327-2.005,9.744-4.5,19.339-7.319,25.646a31.279,31.279,0,0,1-1.552,3.074q-.606,1.04-1.272,2.051a60.276,60.276,0,0,1-4.72,6.262c-.065.085-.14.165-.214.249-.269.319-.549.634-.828.948-1.367,1.542-2.764,2.979-4.116,4.3-1.646,1.607-3.233,3.029-4.655,4.241H696.62l-.065-.03-2.295-1.018s.653-.768,1.746-2.22c.225-.295.464-.619.724-.973.319-.434.664-.913,1.032-1.432.768-1.088,1.642-2.365,2.58-3.812,1.816-2.8,3.887-6.242,5.978-10.228.24-.464.484-.933.728-1.407,0-.015.015-.03.02-.045.414-.808.823-1.642,1.232-2.49a53.191,53.191,0,0,0,4.745-15.143,59.1,59.1,0,0,0,.8-10.8,31.163,31.163,0,0,0-1.467-8.652v0c-.2-.614-.424-1.227-.679-1.836a24.538,24.538,0,0,0-1.632-3.233c-2.819-4.68-5.109-4.875-6.93-9.974a19.8,19.8,0,0,1-1.387-8.527v0a11.615,11.615,0,0,1,.22-1.342v0c.025-.125.06-.254.095-.379a10.131,10.131,0,0,1,1.467-3.233,11.255,11.255,0,0,1,4.994-3.927l.005-.005a14.257,14.257,0,0,1,3.992-1.023c7.289-.649,12.942,5.478,16.031,8.826q1.788,1.938,3.283,3.258c7.768,6.936,9.9,2.5,10.453.215a7.88,7.88,0,0,0,.155-.858Z",
    transform: "translate(-694.26 -144.802)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M790.865,167.308a2.168,2.168,0,0,1-.025.249c.01-.075.015-.15.02-.22C790.86,167.323,790.86,167.313,790.865,167.308Z",
    transform: "translate(-742.652 -156.079)",
    fill: "#0f0f0f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M438.352,378.318H170.89a4.508,4.508,0,1,0,0,9.016H438.352a4.508,4.508,0,0,0,0-9.016Z",
    transform: "translate(-84.692 -190.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M438.6,425H289.846a4.508,4.508,0,0,0,0,9.016H438.6a4.508,4.508,0,1,0,0-9.016Z",
    transform: "translate(-144.262 -214.22)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M235.069,74.151l16.856-7.094,7.23,14.822-17.714,7.23Z",
    transform: "translate(-118.498 -33.813)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M235.069,74.151l16.856-7.094,7.23,14.822-17.714,7.23Z",
    transform: "translate(-118.498 -33.813)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M173.439,68.5l16.629,19.159s-11.568,36.511-23.136,39.765-32.9,19.159-32.9,19.159l-26.751-17.352L120.3,110.075s31.45-43.018,39.765-43.018A53.432,53.432,0,0,1,173.439,68.5Z",
    transform: "translate(-53.755 -33.9)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M134.024,252.211H95.314l-2.447-3.272-9.992-13.357-2.3-3.073S71.9,216.6,73.708,202.143,94.313,184.43,94.313,184.43h.774L118.1,204.652l-1.374,18.82,7.288,12.11,10.01,16.629Z",
    transform: "translate(-36.807 -93.174)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M122.731,304.85H112.356V289.486Z",
    transform: "translate(-56.296 -145.942)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M512.517,249.093l-1.291,6.7-3.2,16.629H443.68c.5-3.727,1.189-9.092,1.923-14.883.072-.578.148-1.16.221-1.746,1.84-14.558,3.854-31.031,3.854-31.031l8.459,1.027,16.412,1.988,6.688.81,17.909,2.173a15.518,15.518,0,0,1,13.372,18.339Z",
    transform: "translate(-223.826 -113.439)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M729.1,313.98H694.2c.531-.625.831-.987.831-.987l10.462-1.728,21.556-3.557s.983,2.541,2.05,6.272Z",
    transform: "translate(-350.323 -155.088)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M453.257,95.766l15.177,21.464-26.474.791L439.119,97.85Z",
    transform: "translate(-221.376 -48.29)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M453.257,95.766l15.177,21.464-26.474.791L439.119,97.85Z",
    transform: "translate(-221.376 -48.29)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-ae755ff6-bb09-410e-86b1-7d1b81a37005-74",
    d: "M303.543,176.688c-1.947-5.618-6.424-9.167-10-7.927s-4.893,6.8-2.945,12.418a14.88,14.88,0,0,0,3.724,5.96l8.552,23.7,11.035-4.25-9.6-22.911A14.881,14.881,0,0,0,303.543,176.688Z",
    transform: "translate(-146.036 -85.034)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M451.288,142.738l-.021,21.874-2.035,8.08-4.186,16.618L442,204.595l-2.27,11.387-.81,4.067q-.917.613-1.826,1.175H384.216a40.676,40.676,0,0,1-4.685-3.207,17.832,17.832,0,0,0,1.782-2.035c1.605-2.118,3.546-5.589,2.357-8.9a6.009,6.009,0,0,1-.239-2.483c.484-6.225,7.013-16.752,7.013-16.752l-1.352-15.624-.593-6.847,4.18-33.385,13.625-7.92,2.352-.228,23.219-1.254,9.6.553.437.119,9.377,19.481Z",
    transform: "translate(-191.473 -62.058)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(244.909 60.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M513.275,314.1H501.706l-.509-5.242-.011-.1,3.275-.224,8.521-.582.148,3.137.116,2.408Z",
    transform: "translate(-497.531 -215.934)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M512.452,148.5l4.859,28.511-3.966,28.056-.618,4.367-1.092,7.711-.336,2.371.011.257.083,1.923H497.656l-.506-5.242-.043-.47-1.034-10.736-.018-.181L493.861,182.3l4.3-16.455.318-1.211v0l1.872-28.175-1.45-12.8-.014-.119.083.054c.076.047.152.094.224.145a28.59,28.59,0,0,1,13.256,24.77Z",
    transform: "translate(-493.861 -123.533)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M357.826,146.892l-5.283-5.464s-11.308,5.1-11.872,7.926-20.53,44.369-20.53,44.369l-8.687-23.2-11.307,7.549s9.073,36.02,17.558,37.711,36.923-42.633,36.923-42.633l3.2-26.258Z",
    transform: "translate(-151.386 -71.476)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M419.5,286.447H10.5a10.56,10.56,0,0,0,0,21.121h409a10.56,10.56,0,0,0,0-21.121Z",
    transform: "translate(0 -144.436)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M433.381,215.125l-.8,37.323a6.644,6.644,0,0,1-6.642,6.5H357.283a6.644,6.644,0,0,1-6.634-6.281l-2.04-37.323a6.644,6.644,0,0,1,6.634-7.006h71.5a6.644,6.644,0,0,1,6.642,6.786Z",
    transform: "translate(-175.913 -105.166)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 16.426,
    cy: 16.426,
    r: 16.426,
    transform: "translate(130.634 16.709)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M224.312,149.647l1.808,19.521,12.291,49.526-10.619,3.722-17.94-53.97-2.478-21.69Z",
    transform: "translate(-104.548 -74.174)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M146.382,215.125l-.8,37.323a6.644,6.644,0,0,1-6.642,6.5H70.283a6.644,6.644,0,0,1-6.634-6.281l-2.04-37.323a6.644,6.644,0,0,1,6.634-7.006h71.5a6.644,6.644,0,0,1,6.642,6.786Z",
    transform: "translate(-30.864 -105.166)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 12.973,
    cy: 5.738,
    rx: 12.973,
    ry: 5.738,
    transform: "translate(122.732 142.465)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M190.242,118.263l7.411-39.5s20.605-2.892,21.328,3.976-.517,40.436-.517,40.436l-28.223-4.916Z",
    transform: "translate(-95.908 -39.446)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M241.688,37.252s10.161-3.627,14.448-5.578,12.8,11.659,12.991,4.471-2.753-10.2-2.753-10.2-.735-15.724-16.577-13.758c0,0,3.485-7.867-7.954-9.084S212.61,29.505,214.2,33.633s3.5,7.541-1.017,11.954S200.2,74.91,206.64,81.613s6.864,9.612,2.451,13.782-14.846,13.237-3.566,14.811-1.032.4,7.377-7,20.68-7.095,16.1-18.962,3.378-28.874,2.382-31.454,2.232-18.963,2.232-18.963,7.512-1.1,8.073,3.423Z",
    transform: "translate(-101.124 -1.534)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(204.419 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 17.881,
    cy: 17.881,
    r: 17.881,
    transform: "translate(1.491 19.789)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M433.164,13.63c-.517.3-1.211-.155-1.376-.731a3,3,0,0,1,.219-1.755l.965-2.858a14.672,14.672,0,0,1,2.892-5.667C438.1.292,441.655-.3,444.855.129c4.109.551,8.164,2.776,10.074,6.456s1.1,8.814-2.355,11.11c4.921,5.64,6.636,11.925,6.365,19.4S450.517,51.463,445.2,56.732c-1.187-.72-2.266-4.092-1.613-5.317s-.282-2.644.526-3.773,1.485.668.667-.454c-.516-.708,1.5-2.337.731-2.761-3.708-2.05-4.941-6.671-7.27-10.211a17.4,17.4,0,0,0-12.7-7.64,12.013,12.013,0,0,0-8.06,1.841,7.554,7.554,0,0,0-3.252,7.3,6.482,6.482,0,0,1,1.348-10.146,10.589,10.589,0,0,1,2.248-9.982c2.4-2.641,12.115-2.192,15.612-1.5l-.271-.464Z",
    transform: "translate(-412.364 0)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M455.14,53.475c4.633.5,7.978,4.513,10.8,8.219,1.628,2.136,3.333,4.495,3.292,7.18-.041,2.715-1.857,5.044-2.724,7.617a11.479,11.479,0,0,0,3.34,12.091,6.669,6.669,0,0,1-7.517-5.214c-.67-3.895,2.282-7.654,1.932-11.59-.308-3.468-3.041-6.137-5.365-8.73s-4.506-6.034-3.437-9.348l-.324-.224Z",
    transform: "translate(-433.797 -26.794)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(288.025 60.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-aec20554-f6ec-4c5b-9d97-717cd04239bf-75",
    d: "M588.092,277.025c-4.589,2.61-6.962,7.093-5.3,10.013s6.727,3.171,11.317.559a13.211,13.211,0,0,0,4.6-4.216l19.3-11.3-5.5-8.945-18.445,12.094a13.212,13.212,0,0,0-5.977,1.8Z",
    transform: "translate(-582.262 -193.222)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M670.138,123.927c-.577-.229-5.638-2.145-10.259.385-5.308,2.907-6.128,9.543-6.415,11.871-.664,5.377,1.293,6.582,1.706,12.025.773,10.184,2.811-1.434-.444,3.214-1.127,1.609-12.632,26.543-18.977,31.427-12.341,9.5-20.177,16.188-20.177,16.188l8.946,9.718a105.3,105.3,0,0,0,26.632-11.88c12.817-8.322,19.226-12.484,24.184-20.624.427-.7,10.643-18.05,5.157-37.234-1.252-4.376-3.544-12.393-10.352-15.091Z",
    transform: "translate(-598.952 -123.017)",
    fill: "#0f0f0f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M732.381,215.125l-.8,37.323a6.644,6.644,0,0,1-6.642,6.5H656.283a6.644,6.644,0,0,1-6.634-6.281l-2.04-37.323a6.644,6.644,0,0,1,6.634-7.006h71.5a6.644,6.644,0,0,1,6.642,6.786Z",
    transform: "translate(-326.974 -105.166)",
    fill: "#3f3d56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.c4fe1ea8b63966cac9230d30498825ab.svg";
export { ForwardRef as ReactComponent };